"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
exports.default = (function (_a) {
    var quantity = _a.quantity, increase = _a.increase, decrease = _a.decrease;
    return (react_1.default.createElement("div", { className: 'quantity-selector' },
        react_1.default.createElement("button", { className: 'quantity-selector__operation', onClick: function () { return decrease(); } },
            react_1.default.createElement("i", { className: 'ss-hyphen' })),
        react_1.default.createElement("span", { className: 'quantity-selector__quantity' }, quantity),
        react_1.default.createElement("button", { className: 'quantity-selector__operation', onClick: function () { return increase(); } },
            react_1.default.createElement("i", { className: 'ss-plus' }))));
});
